import { render } from "./UTile.vue?vue&type=template&id=65716092"
import script from "./UTile.vue?vue&type=script&lang=ts"
export * from "./UTile.vue?vue&type=script&lang=ts"
script.render = render

export default script